module.exports = __webpack_public_path__ + "static/media/template4-carousel.aafbcbf0.png";